<template>
    <div class="px-4 py-2 bg-white border-l-4 border-gray-900 overflow-hidden shadow-sm sm:rounded-lg mb-4 text-lg font-medium ">
        {{title}}
    </div>
</template>
<script>
export default {
    props:['title']
}
</script>